<div *ngIf="!loading && caseDetails">
  <h1 mat-dialog-title style="position: relative">
    Case ID: {{ caseDetails.caseNumber }}
    <mat-chip
      [selectable]="false"
      style="background-color: var(--success); min-height: 1.75rem"
      *ngIf="
        caseDetails.caseResolutionDetails &&
        caseDetails.caseResolutionDetails[
          caseDetails.caseResolutionDetails.length - 1
        ].statusCode === 'Completed'
      ">
      Resolved on
      {{
        caseDetails.caseResolutionDetails[
          caseDetails.caseResolutionDetails.length - 1
        ].modifiedOn | date: "MM/dd/yyyy 'at' hh:mm aa"
      }}
    </mat-chip>
    <button
      mat-icon-button
      aria-label="close dialog"
      mat-dialog-close
      style="
        position: absolute;
        top: -23px;
        right: -23px;
        padding: 5px;
        line-height: 14px;
        min-width: auto;
      ">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <mat-dialog-content>
    <app-support-list-detail
      [caseDetails]="caseDetails"
      [element]="caseDetails"
      [caseDetailsInDialog]="true"
      (expandedElementEvent)="
        setExpandedElement($event)
      "></app-support-list-detail>
  </mat-dialog-content>
</div>
<div
  *ngIf="loading"
  class="d-flex align-items-center justify-content-center flex-column flex-grow-1"
  style="min-height: 50vh">
  <mat-spinner
    class="loading-spinner"
    strokeWidth="6"
    diameter="75"></mat-spinner>
</div>

<div
  *ngIf="caseDetailsError"
  class="d-flex align-items-center justify-content-center flex-column flex-grow-1"
  style="min-height: 50vh; position: relative">
  <p>{{ caseDetailsError }}</p>
  <button mat-dialog-close mat-flat-button disableRipple color="accent">
    Close
  </button>
</div>
